import React, { useState, useEffect } from 'react';
import './SelectBox.css';


const SearchSelectBox = ({ 
  allPlans = [], 
  defaultSelectedOptions = [],
  onChange ,
  error='' // Add onChange to props
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isListVisible, setIsListVisible] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(defaultSelectedOptions);

  useEffect(() => {
    if (defaultSelectedOptions && defaultSelectedOptions.length > 0) {
      setSelectedOptions(defaultSelectedOptions);
    }
  }, [defaultSelectedOptions]);
  

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSelect = (option) => {
    if (!selectedOptions.some(selected => 
        selected.value === option.value || selected.id === option.value)) {
      const updatedOptions = [...selectedOptions, option];
      setSelectedOptions(updatedOptions);
      onChange?.(updatedOptions);
    }
    setSearchTerm('');
    setIsListVisible(false);
  };


  const handleRemove = (optionToRemove, index) => {
    // Remove by index to ensure we only remove the exact item clicked
    const updatedOptions = [...selectedOptions];
    updatedOptions.splice(index, 1);
    setSelectedOptions(updatedOptions);
    // Call onChange to notify parent
    onChange?.(updatedOptions);
  };

  const filteredOptions = allPlans.filter(option =>
    option.label && option.label.toLowerCase().includes(searchTerm.toLowerCase()) &&
    !selectedOptions.some(selected => 
      selected.value === option.value || selected.id === option.value)
  );

  // const displayErrors = error
  const displayErrors = error || '';

  return (
    <div className='search-select-box-container'>
      <span className='choose-active-plan heading-main fts-14 ftw-4'>
        Choose Active Plans
      </span>
      <div className='box-whole'>
        <div className='top-section'>
          <div className='select-container left_container'>
            <span className='normal-text fts-15 black'>Select Plan</span>
          </div>
          <div className='custom-select-box'>
            <input
              type='text'
              placeholder='Search...'
              value={searchTerm}
              onClick={() => setIsListVisible(!isListVisible)}
              onChange={handleSearch}
              className='search-input fts-15 common-text ftw-4'
            />
            <div className='search-select-drop'>
              <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.5 10L0.870833 0.250001L12.1292 0.25L6.5 10Z" fill="#424242"/>
              </svg>
            </div>
            {isListVisible && (
              <div className='options-list-container'>
                <ul>
                  {filteredOptions.length > 0 ? (
                    filteredOptions.map((option, index) => (
                      <li
                        key={index}
                        onClick={() => handleSelect(option)}
                        className='option-item fts-15 common-text ftw-4'
                      >
                        {option.label}
                      </li>
                    ))
                  ) : (
                    <li className='fts-15'>No options found</li>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
        <div className='selected-plans'>
          <ul>
            {selectedOptions.map((option, index) => (
              <li className='list-selected normal-text fts-15 ftw-2 black' key={index}>
                {option.label}
                <div onClick={() => handleRemove(option, index)} className='remove-icon-container'>
                  <svg className='remove-icon' width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="17" height="17" rx="2" fill="#BD3D44"/>
                    <path d="M4 4L13 13" stroke="white" strokeWidth="2"/>
                    <path d="M13 4L4 13" stroke="white" strokeWidth="2"/>
                  </svg>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {displayErrors.length > 0 && (
        <div className="input-error-message fts-12 ">
          {displayErrors}
        </div>
      )}
    </div>
  );
};

export default SearchSelectBox;